import React from "react";
import { Link } from "react-router-dom";
import "../App.css";
import logo from "../assets/logo.png";

function Sidebar() {
  return (
    <div className="sidebar">
      <div className="logo-section">
        <img src={logo} alt="PGN Logo" className="logo" />
      </div>

      <ul className="menu">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/area-biodiversity">Area Biodiversity</Link></li>
        <li><Link to="/tutupan-lahan">Tutupan Lahan</Link></li>
        <li><Link to="/jenis-fauna">Jenis Fauna</Link></li>
        <li><Link to="/jenis-flora">Jenis Flora</Link></li>
        <li><Link to="/biodiversity-flora">Biodiversity Flora</Link></li>
        <li><Link to="/biodiversity-fauna">Biodiversity Fauna</Link></li>
        <li><Link to="/publikasi-file">Publikasi File</Link></li>
      </ul>
    </div>
  );
}

export default Sidebar;
